import { RECORD_ID_KEY_STORAGE, RECORD_ID_RADIX } from '../constants/recordIds';

/**
 * URL-only masking of student / family ids: id XOR a random key drawn once per browser session,
 * so the same record has a different link on another device or after a new session.
 * Not a security boundary: the API scopes every record by teacher.
 */
let memoryKey = null;

const randomKey = () => crypto.getRandomValues(new Uint32Array(1))[0];

const sessionKey = () => {
  if (memoryKey !== null) return memoryKey;
  try {
    const stored = Number(sessionStorage.getItem(RECORD_ID_KEY_STORAGE));
    memoryKey = stored || randomKey();
    sessionStorage.setItem(RECORD_ID_KEY_STORAGE, String(memoryKey));
  } catch {
    memoryKey = memoryKey ?? randomKey();
  }
  return memoryKey;
};

export const encodeRecordId = (id) => ((Number(id) ^ sessionKey()) >>> 0).toString(RECORD_ID_RADIX);

/** Token → integer id, or null for anything this session did not issue. */
export const decodeRecordId = (token) => {
  if (!/^[0-9a-z]+$/.test(String(token || ''))) return null;
  const id = (parseInt(token, RECORD_ID_RADIX) ^ sessionKey()) >>> 0;
  return encodeRecordId(id) === token && id > 0 ? id : null;
};
